export const handleWindowRedirect = (route: string): void => {
  window.location.href = route
}